export const GOOGLE_MAP_API_KEY =
	process.env.NODE_ENV === 'development' ? `${process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY}` : 'AIzaSyBTIpc9xBrElWWC90AbWrBm8erLlTBpPDU';
